import { reactive } from 'vue';

const SECTION_KEYS = [
	'reportSummary',
	'macroNutrient',
	'soilCharacteristics',
	'boronSulfur',
	'soilPhysicalHealth',
	'saturatedExtract',
	'waterSoluble',
	'h3aExtractable',
	'totalCombustion',
	'profileNitrogen',
	'charts'
];

export function useCollapsibleSections() {
	const collapsed = reactive(
		Object.fromEntries(SECTION_KEYS.map(key => [key, true]))
	);

	function collapseAll() {
		SECTION_KEYS.forEach(key => { collapsed[key] = true; });
	}

	function toggle(key) {
		collapsed[key] = !collapsed[key];
	}

	return { collapsed, collapseAll, toggle };
}
